// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2KsvL","topBottomGutter":"Layout_topBottomGutter__2IJOA"};